import { getLoyaltySDK } from "../../api/loyaltySdk";
import { setCustomerLoyaltyConsent } from "../../utils/loyalty/loyaltySdkUtils";
import { setMarketingConsentStatus } from "../../api/customerPreferencesApi";
import { logError, ERROR_TYPE } from "../../utils/newRelicLogger";
import {
  LOYALTY_CONSENT_STATUS,
  LOYALTY_MARKETING_CONSENT_SOURCE,
} from "../../constants";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import AsosWorldModal from "../asosWorldModal/AsosWorldModal";

interface NotifyMeJoinLoyaltyModalProps {
  open: boolean;
  closeModal: () => void;
  onJoin: (args: { consented: boolean }) => void;
  onError: () => void;
}

const NotifyMeJoinLoyaltyModal = ({
  open,
  closeModal,
  onJoin,
  onError,
}: NotifyMeJoinLoyaltyModalProps) => {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };

  const handleError = (sdk: string, action: string, error: Error) => {
    logError(ERROR_TYPE.SdkError, {
      sdk,
      action,
      message: error.message,
    });
    onError();
  };

  const handleJoinLoyalty = async ({ consented }: { consented: boolean }) => {
    try {
      const loyaltySdk = await getLoyaltySDK();
      const success = await setCustomerLoyaltyConsent(
        loyaltySdk,
        LOYALTY_CONSENT_STATUS.OPTED_IN,
      );
      if (!success) {
        handleError(
          "loyalty",
          "setCustomerLoyaltyConsent",
          new Error("Failed to set customer loyalty consent"),
        );
        return;
      }
      if (consented) {
        try {
          await setMarketingConsentStatus({
            sourceReason: LOYALTY_MARKETING_CONSENT_SOURCE,
          });
        } catch (error) {
          handleError(
            "customerPreferences",
            "setMarketingConsentStatus",
            error as Error,
          );
          onJoin({ consented: false });
          return;
        }
      }
      onJoin({ consented });
    } catch (error) {
      handleError("loyalty", "setCustomerLoyaltyConsent", error as Error);
    }
  };

  return (
    <AsosWorldModal
      open={open}
      closeModal={closeModal}
      modalId="NotifyMeJoinLoyaltyModal"
      title={getTranslation("pdp_eap_modal_title")}
      subtitle={getTranslation("pdp_eap_modal_subtitle")}
      copy={
        <>
          {getTranslation("pdp_eap_modal_copy")}{" "}
          <strong>{getTranslation("pdp_eap_modal_optout")}</strong>
        </>
      }
      consentLabel={getTranslation("pdp_eap_modal_checkbox_label")}
      buttonText={getTranslation("pdp_eap_modal_cta")}
      onButtonClick={handleJoinLoyalty}
    />
  );
};

export default NotifyMeJoinLoyaltyModal;
